// src/components/Footer.jsx - FIXED VERSION
import React, { useState } from 'react';

var isGJ = false;

const Footer = () => {
  const domain = window.location.hostname;
  if (domain.includes("gojuris.ai")) {
    isGJ = true;
  }

  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Newsletter subscription:', email);
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  const usefulLinks = [
    { name: 'Home', href: '/' },
    { name: 'Why Us', href: '#services' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Contact', href: '#contact' },
    { name: 'About Us', href: '#about' }
  ];

  const products = [
    { name: 'Desktop Version', href: '#' },
    { name: 'Online Version', href: '#' },
    { name: 'Mobile App', href: '#' },
    { name: 'MAC Version', href: '#' },
    { name: 'Ubuntu Version', href: '#' }
  ];

  const socialLinks = [
    { icon: 'bxl-facebook', href: '#', colorClass: 'social-facebook' },
    { icon: 'bxl-twitter', href: '#', colorClass: 'social-twitter' },
    { icon: 'bxl-linkedin', href: '#', colorClass: 'social-linkedin' },
    { icon: 'bxl-instagram', href: '#', colorClass: 'social-instagram' },
    { icon: 'bxl-youtube', href: '#', colorClass: 'social-youtube' }
  ];

  return (
    <footer className="modern-footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="row g-4">
            {/* Brand Section */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-brand">
                <div className="brand-logo">
                  <img
                    src={isGJ ? "/logoLe.png" : "/logoLe.png"}
                    alt={isGJ ? 'LJSoft Online' : 'LJSoft Online'}
                    className="footer-logo-img"
                  />
             {/*     <h4 className="brand-name">{isGJ ? 'LJSoft Online' : 'LJSoft Online'}</h4>*/}
                </div>

                <p className="brand-description">
                  Leading legal research platform providing comprehensive legal services 
                  with advanced AI technology and experienced professionals.
                </p>

                {/* Social Links */}
                {/* Social Links */}


                {/* Contact Info */}
                <div className="contact-info-footer">
                  
                  <div className="contact-item">
                    <i className="bx bx-support"></i>
                    <div className="contact-text">
                      <span className="contact-label">Support:</span>
                      <span className="contact-value">9822 89 81 52</span>
                    </div>
                  </div>
                  <div className="contact-item">
                    <i className="bx bx-envelope"></i>
                    <div className="contact-text">
                      <span className="contact-value">{isGJ ? 'support@gojuris.in' : 'contact@ljsoftonline.com'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-section">
                <h5 className="footer-title">Quick Links</h5>
                <ul className="footer-links">
                  {usefulLinks.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        <i className="bx bx-chevron-right"></i>
                        <span>{link.name}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Products */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-section">
                <h5 className="footer-title">Products</h5>
                <ul className="footer-links">
                  {products.map((product, index) => (
                    <li key={index}>
                      <a href={product.href} className="footer-link">
                        <i className="bx bx-chevron-right"></i>
                        <span>{product.name}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Newsletter & Contact */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-section">
                <h5 className="footer-title">Stay Updated</h5>
                <p className="newsletter-description">
                  Subscribe to get the latest legal research tips and updates.
                </p>

                {/* Newsletter Form */}
                <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
                  <div className="newsletter-input-wrapper">
                    <i className="bx bx-envelope"></i>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="newsletter-input"
                      required
                    />
                    <button type="submit" className="newsletter-btn">
                      <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                </form>

                {isSubscribed && (
                  <div className="subscription-success">
                    <i className="bx bx-check-circle"></i>
                    <span>Successfully subscribed!</span>
                  </div>
                )}

                {/* Office Locations */}
                <div className="office-locations">
                  <h6 className="location-title">
                    <i className="bx bx-map"></i>
                    Office Locations
                  </h6>
                  
                  <div className="location-badges">
                    <div className="location-badge">🇮🇳 Delhi</div>
                    <div className="location-badge">🇮🇳 Mumbai</div>
                    <div className="location-badge">🇦🇪 Dubai</div>
                    <div className="location-badge">🇸🇬 Singapore</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>© 2025-2026 | All Rights Reserved</p>
              <p className="company-name">Mudhale Law Agency, Delhi (India)</p>
            </div>

            <div className="footer-bottom-links">
              <a href="#" className="bottom-link">Privacy Policy</a>
              <span className="separator">•</span>
              <a href="#" className="bottom-link">Terms of Service</a>
              <span className="separator">•</span>
              <a href="#" className="bottom-link">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <i className="bx bx-up-arrow-alt"></i>
      </button>

      <style>{`
        .modern-footer {
          background: linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%);
          position: relative;
          overflow: hidden;
        }

        .modern-footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #E91E63, #c41849, transparent);
        }

        .footer-main {
          padding: 60px 0 40px;
          position: relative;
        }

        .footer-brand {
          animation: fadeInUp 0.6s ease 0.1s both;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .brand-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .footer-logo-img {
          
          height: 60px;
          object-fit: contain;
        }

        .brand-name {
          font-size: 24px;
          font-weight: 800;
          color: white;
          margin: 0;
          background: linear-gradient(135deg, #E91E63, #c41849);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .brand-description {
          font-size: 14px;
          color: #a0aec0;
          line-height: 1.7;
          margin-bottom: 24px;
        }

        .social-links {
          display: flex;
          gap: 10px;
          margin-bottom: 28px;
        }

        .social-link {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #a0aec0;
          transition: all 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.1);
          text-decoration: none;
        }

        .social-link:hover {
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
        }

        .social-facebook:hover {
          background: #1877F2;
          border-color: #1877F2;
        }

        .social-twitter:hover {
          background: #1DA1F2;
          border-color: #1DA1F2;
        }

        .social-linkedin:hover {
          background: #0A66C2;
          border-color: #0A66C2;
        }

        .social-instagram:hover {
          background: #E4405F;
          border-color: #E4405F;
        }

        .social-youtube:hover {
          background: #FF0000;
          border-color: #FF0000;
        }

        .social-link i {
          font-size: 20px;
        }

        .contact-info-footer {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }

        .contact-item i {
          font-size: 18px;
          color: #E91E63;
          margin-top: 2px;
        }

        .contact-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .contact-label {
          font-size: 11px;
          color: #718096;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .contact-value {
          font-size: 14px;
          color: #cbd5e0;
          font-weight: 500;
        }

        .footer-section {
          animation: fadeInUp 0.6s ease 0.3s both;
        }

        .footer-title {
          font-size: 18px;
          font-weight: 700;
          color: white;
          margin-bottom: 20px;
          position: relative;
          padding-bottom: 10px;
        }

        .footer-title::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 3px;
          background: linear-gradient(90deg, #E91E63, #c41849);
          border-radius: 2px;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .footer-link {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #a0aec0;
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s ease;
          padding: 4px 0;
        }

        .footer-link i {
          font-size: 16px;
          color: #E91E63;
          transition: transform 0.3s ease;
        }

        .footer-link:hover {
          color: white;
          transform: translateX(5px);
        }

        .footer-link:hover i {
          transform: translateX(3px);
        }

        .newsletter-description {
          font-size: 14px;
          color: #a0aec0;
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .newsletter-form {
          margin-bottom: 16px;
        }

        .newsletter-input-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 6px 6px 16px;
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(255, 255, 255, 0.1);
          border-radius: 50px;
          transition: all 0.3s ease;
        }

        .newsletter-input-wrapper:focus-within {
          border-color: #E91E63;
          box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.1);
        }

        .newsletter-input-wrapper > i {
          font-size: 18px;
          color: #a0aec0;
        }

        .newsletter-input {
          flex: 1;
          background: transparent;
          border: none;
          color: white;
          font-size: 14px;
          outline: none;
          padding: 8px 0;
        }

        .newsletter-input::placeholder {
          color: #718096;
        }

        .newsletter-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border: none;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .newsletter-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 15px rgba(245, 166, 35, 0.4);
        }

        .newsletter-btn i {
          font-size: 20px;
        }

        .subscription-success {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.3);
          border-radius: 10px;
          color: #10b981;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 16px;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .subscription-success i {
          font-size: 18px;
        }

        .office-locations {
          margin-top: 24px;
        }

        .location-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 600;
          color: #cbd5e0;
          margin-bottom: 12px;
        }

        .location-title i {
          font-size: 18px;
          color: #E91E63;
        }

        .location-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .location-badge {
          padding: 6px 14px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          font-size: 13px;
          color: #cbd5e0;
          font-weight: 500;
        }

        .footer-bottom {
          padding: 24px 0;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          background: rgba(0, 0, 0, 0.3);
        }

        .footer-bottom-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
          flex-wrap: wrap;
        }

        .copyright {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .copyright p {
          margin: 0;
          font-size: 14px;
          color: #a0aec0;
        }

        .company-name {
          font-size: 13px;
          color: #718096;
        }

        .footer-bottom-links {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .bottom-link {
          font-size: 14px;
          color: #a0aec0;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .bottom-link:hover {
          color: #E91E63;
        }

        .separator {
          color: #4a5568;
          font-size: 14px;
        }

        .back-to-top {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E91E63, #c41849);
          border: none;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 20px rgba(245, 166, 35, 0.4);
          transition: all 0.3s ease;
          z-index: 999;
        }

        .back-to-top:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(245, 166, 35, 0.6);
        }

        .back-to-top i {
          font-size: 24px;
        }

        @media (max-width: 991px) {
          .footer-main {
            padding: 50px 0 30px;
          }

          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
          }
        }

        @media (max-width: 767px) {
          .footer-main {
            padding: 40px 0 20px;
          }

          .social-links {
            justify-content: center;
          }

          .footer-section {
            text-align: center;
          }

          .footer-title::after {
            left: 50%;
            transform: translateX(-50%);
          }

          .footer-links {
            align-items: center;
          }

          .location-badges {
            justify-content: center;
          }

          .back-to-top {
            width: 45px;
            height: 45px;
            bottom: 20px;
            right: 20px;
          }

          .footer-bottom-links {
            justify-content: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;